<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' ref='form' :inline='true' :model='queryForm' class='query-form' label-width='80px'
                 size='small' @submit.native.prevent>
            <el-form-item label='用户'>
<!--                <el-input v-model='queryForm.userId'></el-input>-->
                <GridSelect
                    style='width: 200px'
                    title='选择用户'
                    labelName='userName'
                    labelValue='id'
                    :value='queryForm.userId'
                    :limit='1'
                    size='small'
                    placeholder='请选择用户'
                    :disabled="marketTurntableRecordState == 'check'"
                    @getValue='getValueUserId'
                    :columns="USER_code"
                    :searchs="USER_search"
                    dataListUrl='/mpp/user/findList'
                    entityBeanName='mppUser'
                    queryEntityUrl='/mpp/user/get'
                >
                </GridSelect>
            </el-form-item>
            <el-form-item>
                <el-button icon='el-icon-search' size='small' type='primary' @click='getMarketTurntableRecordList'>
                    查询
                </el-button>
                <el-button icon='el-icon-refresh' size='small' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
<!--                    <el-button-->
<!--                        icon='el-icon-plus'-->
<!--                        size='small'-->
<!--                        type='primary'-->
<!--                        @click='addMarketTurntableRecord'-->
<!--                    >新建-->
<!--                    </el-button>-->
<!--                    <el-button-->
<!--                        :disabled='multipleSelection.length != 1'-->
<!--                        icon='el-icon-edit'-->
<!--                        plain-->
<!--                        size='small'-->
<!--                        type='warning'-->
<!--                        @click='editMarketTurntableRecord(null)'-->
<!--                    >修改-->
<!--                    </el-button>-->
                    <el-button
                        :disabled='multipleSelection.length <= 0'
                        icon='el-icon-delete'
                        plain
                        size='small'
                        type='danger'
                        @click='deleteMarketTurntableRecord(null)'
                    >删除
                    </el-button>
                </div>

                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate'
                               :http-request='upload'
                               :show-file-list='true'
                               action='#'
                               class='upload-demo'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        class='icon-box'
                        title='搜索'
                        @click='search'
                    >
                      <Icon color='#606266'>
                        <Search />
                      </Icon>
                    </span>
<!--                    <span-->
<!--                        class='icon-box'-->
<!--                        title='下载模板'-->
<!--                        @click='importTemplate'-->
<!--                    >-->
<!--                      <Icon color='#606266'>-->
<!--                        <ArrowDown />-->
<!--                      </Icon>-->
<!--                    </span>-->
<!--                    <span-->
<!--                        class='icon-box'-->
<!--                        title='导入数据'-->
<!--                        @click='isImport'-->
<!--                    >-->
<!--                      <Icon color='#606266'>-->
<!--                        <ArrowExportUp24Regular />-->
<!--                      </Icon>-->
<!--                    </span>-->
<!--                    <span-->
<!--                        class='icon-box'-->
<!--                        title='导出数据'-->
<!--                        @click='exportMarketTurntableRecordList'-->
<!--                    >-->
<!--                      <Icon color='#606266'>-->
<!--                        <ArrowDownload24Regular />-->
<!--                      </Icon>-->
<!--                    </span>-->
                    <span
                        class='icon-box'
                        @click='refreshMarketTurntableRecordList'
                    >
                  <Icon color='#606266'>
                    <Refresh />
                  </Icon>
                </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :cell-style="{padding: '9px'}"
                :data='marketTurntableRecordList'
                :header-cell-style="{padding: '10px'}"
                :header-row-style="{height: '10px'}"
                :row-style="{height: '9px'}"
                border
                height='100%'
                row-key='id'
                size='small'
                @selection-change='handleSelectionChange'
            >
                <el-table-column
                    align='center'
                    type='selection'
                    width='60'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    label='用户ID'
                    prop='userId'
                    width='230'
                >
                    <template slot-scope="scope">
                        <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                        <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                        <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                        <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    label='奖项'
                    prop='itemId'
                    width='230'
                >
                    <template scope='scope'>
                        <div>{{scope.row.item.itemName}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    label='中奖时间'
                    prop='createTime'
                    width='230'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    label='是否领取'
                    prop='isReceived'
                    width='230'
                >
                    <template scope="scope">
                        <div v-if="scope.row.isReceived">是</div>
                        <div v-else>否</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    label='领取结束时间'
                    prop='endTime'
                    width='230'
                ></el-table-column>
                <el-table-column
                    align='center'
                    fixed='right'
                    label='操作'
                    width='300'
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
<!--                            <div @click='checkMarketTurntableRecord(scop.row.id)'>-->
<!--                                <Icon size='16'>-->
<!--                                    <Eye24Regular />-->
<!--                                </Icon>-->
<!--                                <span class='operation-label'>查看</span>-->
<!--                            </div>-->
<!--                            <div @click='editMarketTurntableRecord(scop.row.id)'>-->
<!--                                <Icon size='16'>-->
<!--                                    <Edit24Regular />-->
<!--                                </Icon>-->
<!--                                <span class='operation-label'>修改</span>-->
<!--                            </div>-->
                            <div @click='deleteMarketTurntableRecord(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    :current-page.sync='currentPage'
                    :page-size='pageSize'
                    :page-sizes='[10, 20, 50, 100]'
                    :pager-count='7'
                    :total='totalNum'
                    background
                    layout='total, sizes, prev, pager, next, jumper'
                    @size-change='sizeChange'
                    @current-change='currentChange'
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title='marketTurntableRecordStates[marketTurntableRecordState]'
                :visible.sync='showDialog'
                :modal='false'
                width='60%'
                @close='closeDialog'
            >
                <div>
                    <el-form
                        ref='marketTurntableRecordForm'
                        :inline='true'
                        :model='marketTurntableRecord'
                        :rules='rules'
                        label-width='120px'
                        size='small'
                    >
                        <el-form-item
                            label='用户ID'
                            prop='userId'
                        >
                            <el-input
                                v-model='marketTurntableRecord.userId'
                                :disabled="marketTurntableRecordState == 'check'"
                                size='small'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='奖项ID'
                            prop='itemId'
                        >
                            <el-input
                                v-model='marketTurntableRecord.itemId'
                                :disabled="marketTurntableRecordState == 'check'"
                                size='small'
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot='footer'
                    class='flex justify-end'
                >
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button
                        v-if="marketTurntableRecordState != 'check'"
                        type='primary'
                        @click='submitForm'
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Delete24Regular,
    Edit24Regular,
    Eye24Regular
} from '@v2icons/fluent';
import { ArrowDown, ArrowUp, GridDots, Printer, Refresh, Search } from '@v2icons/tabler';
import { deleteFun, exprotExcel, get, importDate, importTemplate, post } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMarketTurntableRecordList();
                this.getMarketTurntableRecordList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMarketTurntableRecordList();
                this.getMarketTurntableRecordList();
                this.$emit('resetCheckState');
            }
        }
    },
    props:{
        turntableId:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            queryForm: {
                userId: '', //用户ID
                itemId: '', //奖项ID
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            marketTurntableRecordState: 'add',
            marketTurntableRecordStates: {
                add: '新建market_turntable_record',
                check: '查看market_turntable_record',
                edit: '修改market_turntable_record'
            },

            multipleSelection: [],
            marketTurntableRecordList: [],
            marketTurntableRecord: {
                userId: '', //用户ID
                itemId: '', //奖项ID
            },
            btnLoading: false,

            rules: {
                userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                itemId: [{ required: true, message: '奖项ID不能为空', trigger: 'blur' }],
            }
        };
    },
    created() {
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetMarketTurntableRecordList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.marketTurntableRecordList = [];
        },
        resetDialog() {
            this.marketTurntableRecordState = 'add';
            this.showDialog = false;
            this.queryForm = {
                userId: '', //用户ID
                itemId: '', //奖项ID
            };
            this.getMarketTurntableRecordList();
        },
        closeDialog() {
            this.showDialog = false;
            this.marketTurntableRecord = {
                userId: '', //用户ID
                itemId: '', //奖项ID
            };
        },
        submitForm() {
            if (this.marketTurntableRecordState == 'add') {
                this.$refs.marketTurntableRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/market/turntablerecord/add`, { ...this.marketTurntableRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMarketTurntableRecordList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.marketTurntableRecordState == 'edit') {
                this.$refs.marketTurntableRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/market/turntablerecord/edit`, { ...this.marketTurntableRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMarketTurntableRecordList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addMarketTurntableRecord() {
            this.showDialog = true;
            this.marketTurntableRecordState = 'add';
        },
        checkMarketTurntableRecord(marketTurntableRecordId) {
            console.log(marketTurntableRecordId);
            this.currentMarketTurntableRecordId = marketTurntableRecordId;

            this.getMarketTurntableRecordById();
            this.showDialog = true;
            this.marketTurntableRecordState = 'check';
        },
        editMarketTurntableRecord(marketTurntableRecordId) {
            console.log('marketTurntableRecord', marketTurntableRecordId);
            if (marketTurntableRecordId) {
                this.currentMarketTurntableRecordId = marketTurntableRecordId;
                this.getMarketTurntableRecordById();
            } else {
                this.marketTurntableRecord = { ...this.marketTurntableRecord, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.marketTurntableRecordState = 'edit';
        },
        deleteMarketTurntableRecord(marketTurntableRecordId) {
            let ids = '';
            if (marketTurntableRecordId) {
                ids = marketTurntableRecordId;
            } else {
                ids = this.multipleSelection.map((marketTurntableRecord) => marketTurntableRecord.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/market/turntablerecord/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMarketTurntableRecordList();
                            this.getMarketTurntableRecordList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMarketTurntableRecordList() {
            this.resetMarketTurntableRecordList();
            this.getMarketTurntableRecordList();
        },
        getMarketTurntableRecordList(query = {}) {
            this.loading = true;
            get(`/market/turntablerecord/findList`, {
                ...this.queryForm,
                turntableId: this.turntableId,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.marketTurntableRecordList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getMarketTurntableRecordById() {
            get(`/market/turntablerecord/get`, { id: this.currentMarketTurntableRecordId }).then((res) => {
                if (res.success) {
                    this.marketTurntableRecord = { ...this.marketTurntableRecord, ...res.marketTurntableRecord };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportMarketTurntableRecordList() {
            //this.btnLoading = true;
            exprotExcel(`/market/turntablerecord/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/market/turntablerecord/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/market/turntablerecord/importData`, formData);
            this.refreshMarketTurntableRecordList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMarketTurntableRecordList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMarketTurntableRecordList();
        },
        getValueUserId(value) {
            this.queryForm.userId = value;
        },
    }

};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>